$(function () {
  $('.newsletterComponent-submit').on('click', function () {
    $('.newsletterComponent-thankyouContainer').hide();
    $('.newsletterComponent-errorContainer').hide();
    var invalidInputs = formValidation.validateForm($('.newsletterComponent-form'));
    if (invalidInputs.length > 0) {
      return;
    }
    $.ajax({
      type: "POST",
      url: "/post-newsletterSubscription",
      data: {
        "email": $(".newsletterComponent-email").val(),
        "itemId": $("body").data("sc-item")
      },
      success: function success(data) {
        if (!data) {
          $('.newsletterComponent-errorContainer').show();
        } else {
          $('.newsletterComponent-thankyouContainer').show();
          $('.newsletterComponent-subscribeContainer').hide();
        }
      },
      error: function error(request, _error) {
        $('.newsletterComponent-errorContainer').show();
      }
    });
  });
});